import { ark } from "@ark-ui/react/factory";
import type { ComponentProps } from "react";
import { styled } from "@repo/styled-system/jsx";
import { spinner } from "@repo/styled-system/recipes";

export type SpinnerProps = ComponentProps<typeof Spinner>;
export const Spinner = styled(ark.span, spinner);
